import { RESET_STATE } from "@/stores/CommumActionTypes";
import {
	DELETE_RULE, SET_RULE, SET_MODE
} from "./StratificationActionType";

const actions = {
	[SET_RULE]: ({ commit }, rule) =>
	{
		commit(SET_RULE, rule);
	},
	[SET_MODE]: ({ commit }, rule) =>
	{
		commit(SET_MODE, rule);
	},
	[DELETE_RULE]: ({ commit }, index) =>
	{
		commit(DELETE_RULE, index);
	},
	[RESET_STATE]: ({ commit }) =>
	{
		commit(RESET_STATE);
	},
};

export default { actions };
